import GQL from "../gql/gql";
import Events from "./events";
import Html from "./html";

class RecipeBookmarks {
    constructor(
        private html: Html,
        private gql: GQL,
        private events: Events
    ) { }

    delete(index: string, itemId: string, groupId: string): void {
        this.gql.recipeBookmarkDelete(groupId, itemId)
            .then(r => this.events.sendEvent('recipe_deleted_'+groupId, index));
    }

    deleteGroup(groupId: string): void {
        this.gql.recipeBookmarkGroupDelete(groupId)
            .then(r => this.html.hide('#group_' + groupId));
    }

    renameGroup(groupId: string): void {
        const selector = '#group_' + groupId + ' .onl-title-edit INPUT';
        const el = this.html.q(selector) as HTMLInputElement;

        const text = el?.value;
        if (!el || !text) {
            return;
        }

        this.gql.recipeBookmarkGroupAddRename(groupId, text)
            .then(r => {
                const selector = '#group_' + groupId + ' .onl-title-text';
                this.html.writeHTML(selector, text);

                this.html.toggle('#group_' + groupId + ' .onl-title-toggle');
            });
    }

    addGroup(recipeId: number, selector = '#recipe_popup'): void {
        const el = this.html.q('.onl-new-group INPUT') as HTMLTextAreaElement;
        const text = el?.value;
        if (!el || !text.trim()) {
            return;
        }

        const newGroupName = 'GRP_' + (Math.floor(Math.random() * 100000));

        this.gql.recipeBookmarkGroupAddRename(newGroupName, text.trim())
            .then(r => {
                el.value = '';

                this.loadPopup(recipeId, selector);
                this.html.toggle('.onl-new-group-toggle');
            });
    }

    toggle(el: HTMLInputElement, groupId: string, itemId: string): void {
        if (this.html.isChecked(el)) {
            this.gql.recipeBookmarkAddToGroup(groupId, itemId);
        } else {
            this.gql.recipeBookmarkDelete(groupId, itemId);
        }
    }

    togglePopup(recipeId: number, selector = '#recipe_popup'): void {
        const popup = this.html.q(selector) as HTMLElement;
        if (!popup) {
            return;
        }

        if (popup.innerHTML) {
            popup.innerHTML = '';
        } else {
            this.loadPopup(recipeId, selector);
        }
    }

    private loadPopup(recipeId: number, selector: string): void {
        this.html.fetchText('/recipe-bookmarks/' + recipeId)
            .then(html => this.html.writeHTML(selector, html));
    }
}

export default RecipeBookmarks;